import services from './../../../services/service'; // Service Class
import Preset from './../../../mixins/preset.js'; //preset
import SecondHeader from './../../Second-Header/index.vue'; // Second Header
import HorizontalWidget from '../../HorizontalWidget.vue'; // HorizontalWidget
import Sidebar from '../../Sidebar/index.vue'; // Sidebar
import MainFooter from '../../Main-Footer/index.vue'; // Main Footer
import SearchBar from '../../SearchBar.vue'; // Search Bar

let service = new services();

export default {
    name: 'CNdiscounts',
    mixins: [Preset],
    data () {
        return {
            user: {},
            cndiscounts:{},
            cndiscounts_business_categories:{},
            cndiscounts_business_locations:{},
            cndiscount:{},
            cndiscount_prev:{},
            cndiscount_next:{},
            businesses: {},
            business: {},
            cnsurveys: {},
            search: {},
            search_result: "",
            search_message: "",
            panelFlag: false,
            addFlag: false,
            img_url: service.imageURL,
            page_data: {},
            pag_intv: service.pageIntv,
            reviews: {},
            review: {},
            rate: "",
            has_reviewed: false,
            has_rated: false,
            current_page: 0,
            search_mode: false,
            page_set: [],
        }
    },
    components: {
        'second-header': SecondHeader,
        'horizontal-widget': HorizontalWidget,
        'sidebar': Sidebar,
        'main-footer': MainFooter,
        'search-bar': SearchBar
    },
    computed: {
        rateValue: {
            get(){
                //this function will determine what is displayed in the input
                return this.rate;
            },
            set(newVal){
                //this function will run whenever the input changes
                if(this.user.user_id != null){
                    this.rate = newVal;
                    this.rateBusiness();
                }else{
                    localStorage.setItem("cn_prv_page","businesses");//log current page
                    this.preset();
                }
                
                
            }
        }
    },
    methods: {
        isActive(page){
            if(page == this.current_page){
                return true;
            }
        },
        
        setCNdiscount(cndiscount,index){
            this.cndiscount = cndiscount;
            //def
            this.cndiscount_prev = this.cndiscounts[index-1];
            this.cndiscount_next = this.cndiscounts[index+1];
            if(index == 0){
                this.cndiscount_prev = {};
            }else{
                this.cndiscount_prev = this.cndiscounts[index-1];
            }
            if((index+1) == this.cndiscounts.length){
                this.cndiscount_next = {};
            }else{
                this.cndiscount_next = this.cndiscounts[index+1];
            }
            
        },
        //business
        setComponent(business) {
            this.business = business;
            this.panelFlag = true;
            //set has reviewed and has rated
            let reviews = this.business.business_reviews;
            reviews.forEach(function(element) {
                if(this.user.user_id == element.review_user_id){
                    this.has_reviewed = true;
                    console.log(999+element.review_user_id)
                }
            }, this);
            let rating = this.business.business_ratings;
            rating.forEach(function(element) {
                if(this.user.user_id == element.rate_user_id){
                    this.has_rated = true;
                }
            }, this);
                  
        },



        saveComponent(component) {
            this.cnpro = component;

            var credentials = {
                save_category: 2, // 2 for business
                save_business: this.business.business_id, //forbusiness
                save_cnpro: 0,
                save_user: this.user.user_id || 'nill'
            }
            service.saveListing(this, credentials).then(function(data) {
            if(data.body.status == 201) {
                toastr.success('Business Saved!!', 'Success!');
            }else if(data.body.status == 400) {
                toastr.error('Sorry, could not process information', 'Warning!');        
            }else if(data.body.status == 500) {
               toastr.error(data.body.message, 'Warning!');  
            }else {
                toastr.error('Please Log In to Save', 'Warning!');        
            }
            
            })
        },
       

        setBusiness() {
            var credentials = {
                data_item: localStorage.getItem("cityneeds_search_business")
            }
            localStorage.removeItem("cityneeds_search_business"); //remove
            localStorage.removeItem("cityneeds_search_city"); 
            localStorage.removeItem("cityneeds_search_keywords"); 
            localStorage.removeItem("cityneeds_search_type");
            service.getDataItem(this, credentials, 2).then(function(data) {
            if(data.body.status == 200) {
                //get the business
                service.getBusiness(this, data.body.data).then(data2 => {
                if(data2.body.status == 200) {
                    this.business = data2.body.data;
                    this.panelFlag = true;
                   
                }
                }).catch((err) => {
                    if(err) {
                        //toastr.error('Sorry, could not process information', 'Warning!');
                    }
                })
               
            }else if(data.body.status == 400) {
             //do something here like redirect to advertised data 
               this.search_message = "Sorry Could not get the Information of entry yet";            
            }
            })
           
        },
        
        getAllBusinessesX() {
           service.getAllBusinesses(this).then(data => {
               if(data.body.status == 200) {
                    this.businesses = data.body.data;
                    localStorage.setItem("cityneeds_cnsearch", data.body.data);
                }
            }).catch((err) => {
                if(err) {
                    //toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        getAllBusinesses(offset,items) {
            service.getSearchBusinesses(this,offset,items).then(data => {
                if(data.body.status == 200) {
                     this.businesses = data.body.data;
                     if((data.body.data_count % this.pag_intv)){
                         this.businesses.count_range = (Math.floor(data.body.data_count/this.pag_intv)+1);
                     }else{this.businesses.count_range = Math.floor(data.body.data_count/this.pag_intv);}
                     this.current_page = items;
                 }
             }).catch((err) => {
                 if(err) {
                     //toastr.error('Sorry, could not process information', 'Warning!');
                 }
             })
         },

        getSearchBusinesses(offset,items) {
           var credentials = {
                search_type: 'businesses',
                search_keywords: this.$route.query.context,
                search_city: this.$route.query.city
            }
            //this.search_result = localStorage.getItem("cityneeds_search_keywords");
            this.search_result = this.$route.query.context;
            service.searchBusinesses(this, credentials,offset,items).then(function(data) {
                if(data.body.status == 200) {
                    this.businesses = data.body.data;
                    if((data.body.data_count % this.pag_intv)){
                        this.businesses.count_range = (Math.floor(data.body.data_count/this.pag_intv)+1);
                    }else{this.businesses.count_range = Math.floor(data.body.data_count/this.pag_intv);}
                     this.current_page = items;
                }else if(data.body.status == 400) {
                    //do something here like redirect to advertised data 
                    this.search_message = "Sorry Could not get the Information of entry yet";            
                }else{
                    this.search_message = "Sorry Could not get the Information of entry yet"; 
                }
            })
        },
        


        getBusiness(business) {
           service.getBusiness(this, business).then(data => {
                if(data.body.status == 200) {
                    this.business = data.body.data;
                }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        

        getCNdiscounts(page,offset,items) {
            service.getCNdiscounts(this,offset,items).then(data => {
                if(data.body.status == 200) {
                    this.cndiscounts = data.body.data;
                    this.page_set = data.body.page_sets;
                    //
                    this.current_page = page;
                    this.isActive(page);
                    //
                    this.setDiscountTimers();
                 }
             }).catch((err) => {
                if(err) {
                    //toastr.error('Sorry, could not process information', 'Warning!');
                }
             })
         },

        setDiscountTimers(){
            let self = this;

            //secs
            setInterval(function() {
                for(let discount of self.cndiscounts){
                    if((discount.cndiscount_countdown_days > 0) || (discount.cndiscount_countdown_hours > 0) || (discount.cndiscount_countdown_minutes > 0)){
                        //check if min is greater than
                        let cntd = discount.cndiscount_countdown_seconds--;
                        if((cntd == 1) || (cntd == 0)){
                            discount.cndiscount_countdown_seconds = 60;
                            //---mins--check
                            if((discount.cndiscount_countdown_minutes == 1) || (discount.cndiscount_countdown_minutes == 0)){
                                //hrs--check
                                if(discount.cndiscount_countdown_minutes == 1){
                                    discount.cndiscount_countdown_hours--;
                                }
                                discount.cndiscount_countdown_minutes = 60;
                            }else{
                                if(discount.cndiscount_countdown_minutes > 1){
                                    discount.cndiscount_countdown_minutes--;
                                }
                            }
                        }else{
                            if(cntd > 1){ //avoid assign to zero
                                discount.cndiscount_countdown_seconds--;
                            }
                        }
                    }
                }
            }, 1000)

            //hrs
            setInterval(function() {
                for(let discount of self.cndiscounts){
                    if(discount.cndiscount_countdown_hours > 1){ //avoid assign to zero
                        discount.cndiscount_countdown_hours--;
                    }
                }
            }, 3600000)

            //
           
        },

        getCNdiscountsBusinessData() {
            service.getCNdiscountsBusinessCategories(this).then(data => {
                if(data.body.status == 200) {
                    this.cndiscounts_business_categories = data.body.data_categories;
                    this.cndiscounts_business_locations = data.body.data_locations;
                 }
             }).catch((err) => {
                if(err) {}
             })
        },

        doSearch(){
            let search_category = {};
            if(this.search.category){
                search_category = this.search.category.cndiscounts_business_category_id;
            }else{
                search_category = 0;
            }
            var payload = {
                search_category: search_category || 0,
                search_location: this.search.location || '',
            }

            let navi = this.$router;
            if(payload.search_category > 0 || payload.search_location != '') {
                this.search_result = "Searching ";
                if(payload.search_category > 0){
                    this.search_result = "Searching "+"for "+this.search.category.cndiscounts_business_category_name;
                }
                if(payload.search_location != ''){
                    this.search_result += " in "+payload.search_location;
                }
                service.searchCNdiscount(this,payload).then(data => {
                    if(data.body.status == 200) {
                        this.cndiscounts = data.body.data;
                        this.page_set = data.body.page_sets;
                        //
                        this.current_page = page;
                        this.isActive(page);
                     }
                 }).catch((err) => {
                    if(err) {
                        //toastr.error('Sorry, could not process information', 'Warning!');
                    }
                 })
           }else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        
        },

        set_cndiscount_image(cnd){
            let image = '/static/assets/img/cndiscount00.jpg';
            if((cnd.cndiscount_media && ((cnd.cndiscount_media != '')&&(cnd.cndiscount_media != 'business-default.jpg')))){
                image = this.img_url + cnd.cndiscount_media;
            }
            return image
        },

         setNavii(url){
             this.$router.push(url)
         },

    },
    mounted: function(){
        document.getElementById('topp04').scrollIntoView();
    },
    created: function(){
        let u_t = localStorage.getItem("cityneeds_token");
        if((u_t != null)) {
            this.preset();
        }else{
            localStorage.setItem("cn_prv_page","businesses");//log current page
        }
        //this.getSearchBusiness();
        // this.getAllBusinesses();
        this.getAllBusinesses(0,this.pag_intv);
        this.getCNdiscounts(1,0,25);
        this.getCNdiscountsBusinessData();
        // this.getCNdiscountsBusinessLocations();

     }
}


// WEBPACK FOOTER //
// ./src/components/CNdiscountSystem/CNdiscounts/script.js